<template>
  <section class="company-page">
    <company-header :h1Content="h1Content" />
    <company-info :introContent="introContent" />
    <company-buttons :products="products" />
    <app-question-panel
      class="mt-16"
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :questions="questions"
    />
  </section>
</template>

<script>
import companyHeader from '@/component/company/CompanyHeader'
import companyInfo from '@/component/company/CompanyInfo'
import appQuestionPanel from '@/component/expansional-question-panel/AppQuestionPanel'
import companyButtons from '@/component/company/CompanyButtons'
import FibaEmeklilikData from '@/data/company-page-data/fiba-emeklilik/FibaEmeklilik.js'

export default {
  metaInfo: {
    title: 'Fiba Emeklilik Fiyatları İçin Teklif Alın, Karşılaştırın',
    meta: [
      {
        name: 'description',
        content:
          'Fiba Emeklilik planlarını inceleyerek avantajlı yatırım şansına sahip olabilirsiniz. Fiba ile birikimlerinizi yöneterek, geleceğinizi güvence altına alın.'
      }
    ]
  },
  name: 'FibaEmeklilik',
  components: {
    companyHeader,
    companyInfo,
    appQuestionPanel,
    companyButtons
  },
  data () {
    return {
      h1Content: 'Fiba Bireysel Emeklilik Sistemi Fiyatları',
      faqTitle: FibaEmeklilikData.faqTitle,
      faqTitleDesc: FibaEmeklilikData.faqTitleDesc,
      products: FibaEmeklilikData.products,
      introContent: FibaEmeklilikData.introContent,
      questions: FibaEmeklilikData.questions
    }
  }
}
</script>
